import { Stack, Typography, Box } from "@mui/material";

export default function LegendItem({
  title,
  description,
  colors,
}: {
  title: string;
  description: string;
  colors?: { color: string; label: string }[];
}) {
  return (
    <Stack spacing={0.5} sx={{ maxWidth: 400 }}>
      <Typography variant="body2" sx={{ fontWeight: 600 }}>
        {title}
      </Typography>
      <Typography variant="caption" sx={{ color: "text.secondary" }}>
        {description}
      </Typography>
      {colors && (
        <Stack spacing={0.25} sx={{ mt: 0.5 }}>
          {colors.map(({ color, label }) => (
            <Stack key={label} direction="row" spacing={0.5} sx={{ alignItems: "center" }}>
              <Box sx={{ width: 12, height: 12, borderRadius: 0.5, bgcolor: color }} />
              <Typography variant="caption" sx={{ fontFamily: "monospace", whiteSpace: "pre" }}>{label}</Typography>
            </Stack>
          ))}
        </Stack>
      )}
    </Stack>
  );
}
